import "react";
import { twMerge as e } from "tailwind-merge";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region src/components/file-item/file-item-name.tsx
function r(e) {
	let t = e.split(/[\\/]/).pop() ?? e, n = t.lastIndexOf(".");
	return n > 0 && n < t.length - 1 ? {
		baseName: t.slice(0, n),
		extensionWithDot: t.slice(n)
	} : { baseName: t };
}
function i({ name: i, className: a }) {
	let { baseName: o, extensionWithDot: s } = r(i);
	return /* @__PURE__ */ n("div", {
		className: e("flex w-full", a),
		title: i,
		children: [/* @__PURE__ */ t("span", {
			className: "truncate",
			children: o
		}), s ? /* @__PURE__ */ t("span", {
			className: "shrink-0",
			children: s
		}) : null]
	});
}
//#endregion
export { i as FileItemName };
